import { render } from "./FlatDiscourse.vue?vue&type=template&id=77a2212a&scoped=true"
import script from "./FlatDiscourse.vue?vue&type=script&lang=js"
export * from "./FlatDiscourse.vue?vue&type=script&lang=js"

import "./FlatDiscourse.vue?vue&type=style&index=0&id=77a2212a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a2212a"]])

export default __exports__